import '../../../css/teasers/person_teaser.css';

export class PersonTeaser {

  constructor() {



  }

}